import React from 'react';

const walletData = [
  {
    name: 'Komodo Wallet',
    features: {
      nonCustodial: true,
      openSource: true,
      mobileApp: true,
      browserExtension: true,
      desktopApp: true,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
  {
    name: 'Trust Wallet',
    features: {
      nonCustodial: true,
      openSource: true,
      mobileApp: true,
      browserExtension: true,
      desktopApp: false,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
  {
    name: 'MetaMask',
    features: {
      nonCustodial: true,
      openSource: true,
      mobileApp: true,
      browserExtension: true,
      desktopApp: false,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
  {
    name: 'Exodus',
    features: {
      nonCustodial: true,
      openSource: false,
      mobileApp: true,
      browserExtension: true,
      desktopApp: true,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
  {
    name: 'Coinomi',
    features: {
      nonCustodial: true,
      openSource: false,
      mobileApp: true,
      browserExtension: true,
      desktopApp: false,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
  {
    name: 'Crypto.com',
    features: {
      nonCustodial: true,
      openSource: false,
      mobileApp: true,
      browserExtension: true,
      desktopApp: false,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
  {
    name: 'Guarda Wallet',
    features: {
      nonCustodial: true,
      openSource: false,
      mobileApp: true,
      browserExtension: true,
      desktopApp: true,
      multiLanguage: false,
      fiatOnramp: true,
    },
  },
  {
    name: 'Coinbase Wallet',
    features: {
      nonCustodial: true,
      openSource: false,
      mobileApp: true,
      browserExtension: true,
      desktopApp: false,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
  {
    name: 'Edge Wallet',
    features: {
      nonCustodial: true,
      openSource: false,
      mobileApp: true,
      browserExtension: true,
      desktopApp: false,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
  {
    name: 'Zengo',
    features: {
      nonCustodial: true,
      openSource: false,
      mobileApp: true,
      browserExtension: false,
      desktopApp: false,
      multiLanguage: false,
      fiatOnramp: true,
    },
  },
  {
    name: 'SafePal',
    features: {
      nonCustodial: true,
      openSource: false,
      mobileApp: true,
      browserExtension: true,
      desktopApp: false,
      multiLanguage: true,
      fiatOnramp: true,
    },
  },
];

const features = [
  { id: 'nonCustodial', label: 'Non-Custodial' },
  { id: 'openSource', label: 'Open Source' },
  { id: 'mobileApp', label: 'Mobile App' },
  { id: 'browserExtension', label: 'Browser Extension' },
  { id: 'desktopApp', label: 'Desktop App' },
  { id: 'multiLanguage', label: 'Multi Language' },
  { id: 'fiatOnramp', label: 'Fiat On-Ramp' },
];

const WalletComparison = () => {
  return (
    <div className='mx-auto w-full max-w-[95vw]'>
      <div className='overflow-x-auto rounded-lg shadow-lg'>
        <div className='inline-block min-w-full align-middle'>
          <table className='min-w-full border-collapse bg-[#061621]'>
            <colgroup>
              <col className='w-[160px] sm:w-[200px]' /> {/* Feature names column - responsive */}
              {walletData.map((wallet, index) => (
                <col
                  key={`col-${index}`}
                  className='w-[100px] sm:w-[120px]'
                /> /* Wallet columns - responsive */
              ))}
            </colgroup>
            <thead>
              <tr className='border-b border-[#919ad5]'>
                <th className='sticky left-0 bg-[#061621] p-1 text-left text-xs font-medium text-[#8B8B8B] 2xl:whitespace-nowrap 2xl:p-3 2xl:text-sm 3xl:text-[15px]'></th>
                {walletData.map((wallet) => (
                  <th
                    key={wallet.name}
                    className='p-1 text-center text-xs font-medium text-[#289fc6] 2xl:whitespace-nowrap 2xl:p-3 2xl:text-sm 3xl:text-[15px]'
                  >
                    {wallet.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className='divide-y divide-[#919ad5] border-b border-r border-[#919ad5]'>
              {features.map((feature) => (
                <tr key={feature.id}>
                  <td className='sticky left-0 bg-[#061621] p-1 text-xs font-medium text-[#289fc6] 2xl:whitespace-nowrap 2xl:p-3 2xl:text-sm 3xl:text-[15px]'>
                    {feature.label}
                  </td>
                  {walletData.map((wallet) => (
                    <td
                      key={`${wallet.name}-${feature.id}`}
                      className='border-l border-[#919ad5] text-center'
                    >
                      {wallet.features[feature.id] ? (
                        <span className='flex items-center justify-center p-1 2xl:p-3'>
                          <svg
                            className={` ${wallet.name === 'Komodo Wallet' ? 'h-5 w-5 fill-[#e6bc41] sm:h-6 sm:w-6' : 'fill-[#00b42c]'} h-4 w-4 sm:h-5 sm:w-5`}
                            clip-rule='evenodd'
                            fill-rule='evenodd'
                            image-rendering='optimizeQuality'
                            shape-rendering='geometricPrecision'
                            text-rendering='geometricPrecision'
                            viewBox='0 0 43.3492 43.3492'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <g id='Layer_x0020_1'>
                              <g id='_553428304'>
                                <path
                                  id='_553427992'
                                  d='m19.2886 31.335c-.2115 0-.3878-.141-.4583-.3173-.0352-.0705-3.0674-7.8976-7.7566-10.8592-.9167-.5641-1.6217-1.1635-1.3397-2.5033.282-1.3045 1.1635-2.0449 2.75-2.3975 2.8205-.5994 5.8526 3.7725 6.9809 5.5707 3.9487-5.7469 11.8463-14.7728 23.3401-15.8305.5545-.065.7595.7569.2468.9872-.1763.0705-16.6062 7.5804-23.2697 25.0679-.1057.1762-.282.282-.4935.282z'
                                />
                              </g>
                            </g>
                          </svg>
                        </span>
                      ) : (
                        <span className='inline-flex items-center justify-center'>
                          <svg
                            className='h-4 w-4 text-[#FF4E4E] sm:h-5 sm:w-5'
                            fill='currentColor'
                            viewBox='0 0 20 20'
                          >
                            <path
                              fillRule='evenodd'
                              d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                              clipRule='evenodd'
                            />
                          </svg>
                        </span>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default WalletComparison;
